import type {
  RestangularEmployee,
  RestangularPosition,
} from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';

const isAddWagesStepVisible = (
  employees: RestangularEmployee[],
  positions: RestangularPosition[]
): boolean => {
  const hasAddedEmployeeWages = employees.some(({ wages }) => wages?.base?.[0]?.regularRate);
  const hasAddedPositionWages = positions.some(({ wages }) => wages?.[0]?.regularRate);

  return hasAddedEmployeeWages || hasAddedPositionWages;
};

export default isAddWagesStepVisible;
